import { render, staticRenderFns } from "./expandTable.vue?vue&type=template&id=82efd2d4&scoped=true"
import script from "./expandTable.vue?vue&type=script&lang=js"
export * from "./expandTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82efd2d4",
  null
  
)

export default component.exports